import { useState } from "react";
import { Drawer, Popover } from "antd";
import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { FilterPopoverProps } from "./types";
import BaseButton from "../Button/BaseButton";
import { useResponsive } from "@/shared/hooks/useBreakpoints";

import "./styles.css";

const FilterPopover = ({
  fields,
  activeFilterCount,
  title,
  handleClear,
  handleSearch,
}: FilterPopoverProps) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const { isMobile } = useResponsive();

  const handleFiltersClear = () => {
    handleClear();
    setIsOpen(false);
  };

  const handleFilterSearch = () => {
    handleSearch();
    setIsOpen(false);
  };

  const popoverContent = (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-250">
        {fields.map((field, index) => (
          <div
            key={`${field.label}-${index}`}
            className="flex flex-col gap-100"
          >
            <p className="body-s-medium">{field.label}</p>
            {field.component}
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center">
        <BaseButton
          variant="tertiary"
          size="small"
          onClick={handleFiltersClear}
          disabled={activeFilterCount === 0}
        >
          {t("buttons.clearFilters")}
        </BaseButton>

        <BaseButton
          variant="primary"
          size="small"
          leadingIcon={<SearchOutlined />}
          onClick={handleFilterSearch}
        >
          {t("buttons.search")}
        </BaseButton>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <div>
        <Drawer
          open={isOpen}
          onClose={() => setIsOpen(false)}
          placement="bottom"
          title={title}
        >
          {popoverContent}
        </Drawer>

        <BaseButton
          variant="tertiary"
          size="small"
          leadingIcon={<FilterOutlined />}
          className="filter-popover-button flex items-center justify-center gap-200"
          onClick={() => setIsOpen(true)}
        >
          {t("buttons.filters")}

          {activeFilterCount && activeFilterCount > 0 ? (
            <span>{activeFilterCount}</span>
          ) : null}
        </BaseButton>
      </div>
    );
  }

  return (
    <Popover
      content={popoverContent}
      title={title}
      trigger="click"
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottomRight"
      classNames={{ root: "filters-popover" }}
    >
      <BaseButton
        variant="tertiary"
        size="small"
        leadingIcon={<FilterOutlined />}
        className="filter-popover-button flex items-center justify-center gap-200"
      >
        {t("buttons.filters")}

        {activeFilterCount && activeFilterCount > 0 ? (
          <span>{activeFilterCount}</span>
        ) : null}
      </BaseButton>
    </Popover>
  );
};

export default FilterPopover;
